import { render, staticRenderFns } from "./BotaoImprimir.vue?vue&type=template&id=b6467eb4&scoped=true&"
import script from "./BotaoImprimir.vue?vue&type=script&lang=js&"
export * from "./BotaoImprimir.vue?vue&type=script&lang=js&"
import style0 from "./BotaoImprimir.vue?vue&type=style&index=0&id=b6467eb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6467eb4",
  null
  
)

export default component.exports